var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"lg"}},[_c('HeaderSection',{attrs:{"header":_vm.$prismic.asHtml(_vm.slice.primary.h2),"teaser":_vm.$prismic.asText(_vm.slice.primary.text),"align":"left"}}),_vm._v(" "),_c('ul',{staticClass:"list"},_vm._l((_vm.lenderIds),function(lenderId,index){return _c('ListItem',{key:index,attrs:{"id":lenderId}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }